import { generateId } from "@@/utilities/generate-id";

const SECTION_THEME_REFERENCE = "SECTION_THEME_REFERENCE";
type SECTION_THEME_REFERENCE = typeof SECTION_THEME_REFERENCE;

type SectionThemeReference = {
    _id: string;
    _type: "SECTION_THEME_REFERENCE";
    name: string;
    sectionThemeId: string;
};

const createSectionThemeReference = (
    params: Omit<SectionThemeReference, "_id" | "_type"> & {
        _id?: string;
    },
): SectionThemeReference => {
    return {
        ...params,
        _id: params._id || generateId({ prefix: "section_theme_reference__" }),
        _type: "SECTION_THEME_REFERENCE",
    };
};

export { createSectionThemeReference, SECTION_THEME_REFERENCE };
export type { SectionThemeReference };
